import { createTheme } from "@mui/material/styles";

/**
 * 프로젝트 전역 색상 팔레트
 * 이 파일 한 곳에서만 색상을 변경하면 전체 UI에 반영됩니다.
 */
export const colorPalette = {
  primary: "#2d6cdf",
  secondary: "#f1f2f6",
  border: "#dcdfe6",
  textPrimary: "#1a1f36",
  textSecondary: "#4f566b",
  background: "#f5f7fa",
  white: "#ffffff",
  error: "#d93025",
  activeBg: "#e8f0fe", // 리스트 아이템 선택 시 배경색
};

/**
 * 프로젝트 전역 MUI 테마
 * Dashboard, Login 등 모든 페이지에서 공유합니다.
 */
export const theme = createTheme({
  palette: {
    primary: {
      main: colorPalette.primary,
    },
    background: {
      default: colorPalette.background,
    },
  },
  typography: {
    fontFamily: "'Inter', 'Noto Sans KR', sans-serif",
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          border: `1px solid ${colorPalette.border}`,
          boxShadow: "none",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: 8,
          fontWeight: 600,
        },
      },
    },
  },
});
